import type { ReactNode } from "react";

export interface MetricSectionProps {
  title: string;
  cols?: number;
  children: ReactNode;
}

export function MetricSection({ title, cols = 4, children }: MetricSectionProps) {
  return (
    <section style={{ marginBottom: 32 }}>
      <h3
        style={{
          fontSize: 12,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          color: "var(--text-secondary)",
          margin: "0 0 12px 0",
        }}
      >
        {title}
      </h3>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${cols}, minmax(180px, 1fr))`,
          gap: 12,
        }}
      >
        {children}
      </div>
    </section>
  );
}
